<div>
  <ng-container *ngIf="scrollService.isMobile$ | async">
    <app-mobile-toolbar
      (homeClicked)="linkClicked($event)"
      (openMobileMenu)="openMobileMenu()"
    ></app-mobile-toolbar>
  </ng-container>
  <ng-container *ngIf="!(scrollService.isMobile$ | async)">
    <app-toolbar (linkClicked)="linkClicked($event)"></app-toolbar>
  </ng-container>

  <div class="intro-section">
    <div class="introducing">INTRODUCING</div>
    <div class="title">My Read App</div>
    <div class="subtitle">
      Transparent Metering<br />
      for Every Resident
    </div>
    <div class="image-container">
      <img src="/assets/my-read-app/phones.png" />
    </div>
  </div>
  <div class="smart-transparency">
    <p class="description">
      A <span class="emphasize">simple</span> way to provide residents with
      <span class="emphasize">real-time</span> utility data, improve
      <span class="emphasize">transparency</span>, and
      <span class="emphasize">eliminate</span> the cost of in-unit hardware.
    </p>
    <a
      target="_blank"
      href="https://docs.nextcenturymeters.com/My-Read-App-Installation-Guide.pdf"
      class="learn-more"
      >LEARN MORE</a
    >
    <div class="phone-container">
      <img src="/assets/my-read-app/phone.png" />
    </div>
    <div class="transparency">Smarter Transparency</div>
    <table class="transparency-table">
      <tr class="transparency-item">
        <td>
          <i class="icon-pulse"></i>
        </td>
        <td>
          <div class="item-header">Real-Time Meter Readings</div>
          <div class="item-description">
            Residents can check their usage at any time.
          </div>
        </td>
      </tr>
      <tr class="transparency-item">
        <td>
          <i class="icon-bar-chart-fair"></i>
        </td>
        <td>
          <div class="item-header">Daily, Weekly, & Monthly Insights</div>
          <div class="item-description">
            Identifies trends & potential leaks to promote conservation.
          </div>
        </td>
      </tr>
      <tr class="transparency-item">
        <td>
          <i class="icon-log-in"></i>
        </td>
        <td>
          <div class="item-header">No Logins Required</div>
          <div class="item-description">
            Secure access with a unique meter serial number.
          </div>
        </td>
      </tr>
      <tr class="transparency-item">
        <td>
          <i class="icon-smartphone"></i>
        </td>
        <td>
          <div class="item-header">Accessible Anywhere</div>
          <div class="item-description">
            Works on mobile, tablet, or desktop.
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="why-section">
    <div class="why-title">Why Choose My Read App?</div>
    <table>
      <tr>
        <td>
          <div><i class="icon-check-circle"></i></div>
          <div>Ensures Compliance</div>
        </td>
        <td>
          <div><i class="icon-trending-down"></i></div>
          <div>Reduces Cost</div>
        </td>
      </tr>
      <tr>
        <td>
          <div><i class="icon-thumbs-up"></i></div>
          <div>Increases Resident Satisfaction</div>
        </td>
        <td>
          <div><i class="icon-building"></i></div>
          <div>Scales for any Property</div>
        </td>
      </tr>
    </table>
  </div>
  <div class="integration-section">
    <div class="integration-title">
      Seamless Integration<br />
      with NextCentury
    </div>
    <div class="content-container">
      <table>
        <tr>
          <td>
            <div class="integration-item-header">DISPLAY MODE</div>
            <div class="integration-item-description">
              Kiosk mode allows residents to access data in a common area.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="integration-item-header">NETWORK SUPPORT</div>
            <div class="integration-item-description">
              Supports NextCentury AMR and AMI Networks.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="integration-item-header">INSTANT TRANSPARENCY</div>
            <div class="integration-item-description">
              Delivers reads as soon as meter data is captured.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="integration-item-header">CERTIFICATION</div>
            <div class="integration-item-description">
              Meets NTEP remote display requirements.
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="integration-item-header">EXPERT SUPPORT</div>
            <div class="integration-item-description">
              Backed by our industry-leading customer service.
            </div>
          </td>
        </tr>
      </table>
      <div class="property-container">
        <img src="/assets/my-read-app/property.svg" />
      </div>
    </div>
  </div>
  <div class="learn-more-section">
    <p>
      Stay <span class="emphasize">compliant</span>, reduce disputes, and give
      residents the <span class="emphasize">insights</span> they need with the
      <span class="emphasize">My Read App</span>.
    </p>
    <a
      target="_blank"
      href="https://docs.nextcenturymeters.com/My-Read-App-Installation-Guide.pdf"
      class="learn-more-button-white"
      >LEARN MORE</a
    >
  </div>
  <ng-container *ngIf="scrollService.isMobile$ | async">
    <app-mobile-footer></app-mobile-footer>
  </ng-container>
  <ng-container *ngIf="!(scrollService.isMobile$ | async)">
    <app-footer id="footer" (linkClicked)="linkClicked($event)"></app-footer>
  </ng-container>
</div>
